import {ToastProvider} from "./components/ui/toast";
import {Toaster} from "./components/ui/toaster";
import {UserContext} from "./contexts/UserContext";
import {SidebarContext} from "./contexts/SidebarContext";
import Header from "./layouts/Header";
import {ProjectBreadCrumb} from "./layouts/ProjectBreadCrumb";
import Sidebar from "./layouts/Sidebar";
import {whoAmIResponse} from "@models/project";
import React, {Suspense, useState} from "react";
import {Outlet} from "react-router-dom";

type layoutProps = {
    role: whoAmIResponse;
};

const AppLayout = ({role}: layoutProps) => {
    // lives here so any page under <Outlet/> can collapse the sidebar
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    return (
        <Suspense fallback={null}>
            <UserContext.Provider value={role}>
            <SidebarContext.Provider value={{collapsed: sidebarCollapsed, setCollapsed: setSidebarCollapsed}}>
                <ToastProvider>
                    <div className="min-h-screen flex flex-col">
                        <Header/>
                        <div className="flex flex-1">
                            <Sidebar
                                role={role}
                                className="lg:w-60 w-60 min-h-screen bg-[#E6D3C9] flex-shrink-0"
                            />
                            {/* min-w-0 - otherwise wide tables stretch the page instead of scrolling */}
                            <div className="flex-1 flex flex-col min-w-0">
                                <div
                                    className="flex-1 overflow-y-auto p-4"
                                    style={{
                                        maxHeight: "calc(100vh - 64px)",
                                    }}
                                >
                                    <div className="md-lg:hidden">
                                        <ProjectBreadCrumb/>
                                    </div>
                                    <Toaster/>
                                    <Outlet/>
                                </div>
                            </div>
                        </div>
                    </div>
                </ToastProvider>
            </SidebarContext.Provider>
            </UserContext.Provider>
        </Suspense>
    );
};

export default React.memo(AppLayout);
